module.exports = __webpack_public_path__ + "img/efficacy-stat.fafe35a6.png";